import { jsx as _jsx } from "react/jsx-runtime";
import { useConfigContext } from '@/hoc';
import { Template1 } from './template1';
import { Template2 } from './template2';
export var JobListingTemplateMap = function (_a) {
    var isPreview = _a.isPreview;
    var templateId = useConfigContext().config.templateId;
    switch (templateId) {
        case 1:
            return _jsx(Template1, { isPreview: isPreview });
        case 2:
            return _jsx(Template2, { isPreview: isPreview });
        default:
            return _jsx(Template1, { isPreview: isPreview });
    }
};
